<button
	class="language-chooser-button"
	mat-button
	color="primary"
	[matMenuTriggerFor]="menu"
>
    <div fxFlex fxLayout="row" fxLayoutGap="5%" class="language-chooser">
		<img width="28px" class="default_icon" src="{{ this.languageIcon }}" />
		<span class="mat-typography">{{ this.locale | titlecase }}</span>
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/keyboard_arrow_down/public"
		/>
	</div>
</button>
<mat-menu class="language-chooser-menu" #menu="matMenu" xPosition="before"> <mat-menu #menu="matMenu" class="translationMenuContainerDropDown"> <mat-menu #menu="matMenu" class="translationMenuContainerDropDown">
	<button mat-menu-item (click)="changeLanguage('en')" class="enChooser">
		<span id="languageChooser_en_button" i18n="@@languageChooser_en_button"
			>EN - English</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('nl')" class="nlChooser">
		<span id="languageChooser_nl_button" i18n="@@languageChooser_nl_button"
			>NL - Nederlands</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('es')" class="esChooser">
		<span id="languageChooser_es_button" i18n="@@languageChooser_es_button"
			>ES - Español</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('de')" class="deChooser">
		<span id="languageChooser_de_button" i18n="@@languageChooser_de_button"
			>DE - Deutsch</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('fr')" class="frChooser">
		<span id="languageChooser_fr_button" i18n="@@languageChooser_fr_button"
			>FR - Français</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('bg')" class="bgChooser">
		<span id="languageChooser_bg_button" i18n="@@languageChooser_bg_button"
			>BG - Bulgarian</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('hr')" class="hrChooser">
		<span id="languageChooser_hr_button" i18n="@@languageChooser_hr_button"
			>HR - Croatian</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('cs')" class="csChooser">
		<span id="languageChooser_cs_button" i18n="@@languageChooser_cs_button"
			>CS - Czech</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('da')" class="daChooser">
		<span id="languageChooser_da_button" i18n="@@languageChooser_da_button"
			>DA - Danish</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('fi')" class="fiChooser">
		<span id="languageChooser_fi_button" i18n="@@languageChooser_fi_button"
			>FI - Finnish</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('el')" class="elChooser">
		<span id="languageChooser_el_button" i18n="@@languageChooser_el_button"
			>EL - Greek</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('hu')" class="huChooser">
		<span id="languageChooser_hu_button" i18n="@@languageChooser_hu_button"
			>HU - Hungarian</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('it')" class="itChooser">
		<span id="languageChooser_it_button" i18n="@@languageChooser_it_button"
			>IT - Italian</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('pl')" class="plChooser">
		<span id="languageChooser_pl_button" i18n="@@languageChooser_pl_button"
			>PL - Polish</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('pt')" class="ptChooser">
		<span id="languageChooser_pt_button" i18n="@@languageChooser_pt_button"
			>PT - Portuguese</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('ro')" class="roChooser">
		<span id="languageChooser_ro_button" i18n="@@languageChooser_ro_button"
			>RO - Romanian</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('sk')" class="skChooser">
		<span id="languageChooser_sk_button" i18n="@@languageChooser_sk_button"
			>SK - Slovak</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('sv')" class="svChooser">
		<span id="languageChooser_sv_button" i18n="@@languageChooser_sv_button"
			>SV - Swedish</span
		>
	</button>
	<button mat-menu-item (click)="changeLanguage('uk')" class="ukChooser">
		<span id="languageChooser_uk_button" i18n="@@languageChooser_uk_button"
			>UK - Ukrainian</span
		>
	</button>
</mat-menu>
